var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, Pivot, R } from "apparatus/library/common";
import { Mounted } from "apparatus/library/physics/electric/mounted/utils";
import { Group, Path } from "paper";
import { staticImplements } from "types";
let MountedBuzzer = class MountedBuzzer {
    render(appearance) {
        const { base, jacks, snaps } = Mounted.renderPlate({ appearance, width: 80, height: 55 });
        // Draw buzzer
        const width = 40;
        const height = 25;
        const depth = 15;
        const buzzer = new Group([
            // Shade.
            new Path.Rectangle(R(0, 0, width, height + depth, Pivot.TOP_CENTER), 4.0).withFill("#888888"),
            // Top.
            new Path.Rectangle(R(0, 0, width, height, Pivot.TOP_CENTER), 4.0).withFill("#aaaaaa"),
            // Outline.
            new Path.Rectangle(R(0, 0, width, height + depth, Pivot.TOP_CENTER), 4.0).withStroke("default"),
        ]);
        // Add grills
        for (var y = 5; y <= height - 4; y += 5) {
            buzzer.addChild(new Path.Line(P(-14, y), P(14, y)).withStroke(2, "#666666"));
        }
        buzzer.withPositionDelta(P(40, -10));
        const graphic = new Group([base, jacks, buzzer]);
        const hitShape = graphic.bounds.toShape();
        const pivot = hitShape.bounds.center;
        return {
            graphic,
            hitShape,
            pivot,
            snapping: [...snaps]
        };
    }
};
MountedBuzzer.properties = {
    label: "Buzzer",
    defaultAppearance: Object.assign({}, Mounted.defaultAppearance),
    appearanceSpecs: [
        ...Mounted.appearanceSpecs,
    ],
};
MountedBuzzer = __decorate([
    staticImplements()
], MountedBuzzer);
export { MountedBuzzer };
